<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <date-field
          slot="fa_date"
          :label="customLabel.fa_date || '申请日期'"
          v-model="form.main.fa_date"
        />
        <employee-field
          slot="fa_pleaseman"
          :label="customLabel.fa_pleaseman || '申请人'"
          v-model="form.main.fa_pleaseman"
          @select="onSelectPleaseman($event, form.main)"
        />
        <div class="weui-cell" slot="fa_department">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fa_department || "申请部门"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              disabled
              v-model="form.main.fa_department"
              placeholder="选择申请人后自动填写"
            />
          </div>
        </div>
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="fa_type"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fa_type || "申请类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.fa_type"
              placeholder="请选择"
            >
              <option>个人</option>
              <option>部门</option>
              <option>公司</option>
            </select>
          </div>
        </div>
        <currency-field
          slot="fa_currency"
          :label="customLabel.fa_currency || '币种'"
          v-model="form.main.fa_currency"
        />
        <div class="weui-cell" slot="fa_amount">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fa_amount || "申请金额（元）"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.fa_amount"
              placeholder="请输入"
            />
          </div>
        </div>
        <fee-type-field
          :label="customLabel.fa_class || '费用类型'"
          v-model="form.main.fa_class"
          slot="fa_class"
          @select="onSelectFeeType($event)"
        />
        <div
          class="weui-cell weui-cell_active weui-cell_switch"
          slot="fa_islimit"
        >
          <div class="weui-cell__bd">
            {{ customLabel.fa_islimit || "参与额度管控" }}
          </div>
          <div class="weui-cell__ft">
            <input
              class="weui-switch"
              v-model="form.main.fa_islimit"
              type="checkbox"
              v-bind:true-value="1"
              v-bind:false-value="0"
            />
          </div>
        </div>
        <div class="weui-cell" slot="fa_sourcetype">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fa_sourcetype || "来源类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.fa_sourcetype }}
          </div>
        </div>
        <div class="weui-cell" slot="fa_sourcecode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fa_sourcecode || "来源单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.fa_sourcecode }}
          </div>
        </div>
        <div class="weui-cell" slot="fa_content">
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              :placeholder="customLabel.fa_content || '费用内容'"
              rows="3"
              v-model="form.main.fa_content"
              maxlength="80"
            ></textarea>
            <div class="weui-textarea-counter">
              <span>{{
                form.main.fa_content ? form.main.fa_content.length : 0
              }}</span
              >/100
            </div>
          </div>
        </div>
        <custom-field
          :label="customLabel.fa_text1 || '自定义字段1'"
          v-model="form.main.fa_text1"
          :caller="caller"
          fieldName="fa_text1"
          slot="fa_text1"
          hidden="true"
        />
        <custom-field
          :label="customLabel.fa_text2 || '自定义字段2'"
          v-model="form.main.fa_text2"
          :caller="caller"
          fieldName="fa_text2"
          slot="fa_text2"
          hidden="true"
        />
        <custom-field
          :label="customLabel.fa_text3 || '自定义字段3'"
          v-model="form.main.fa_text3"
          :caller="caller"
          fieldName="fa_text3"
          slot="fa_text3"
          hidden="true"
        />
        <custom-field
          :label="customLabel.fa_text4 || '自定义字段4'"
          v-model="form.main.fa_text4"
          :caller="caller"
          fieldName="fa_text4"
          slot="fa_text4"
          hidden="true"
        />
        <custom-field
          :label="customLabel.fa_text5 || '自定义字段5'"
          v-model="form.main.fa_text5"
          :caller="caller"
          fieldName="fa_text5"
          slot="fa_text5"
          hidden="true"
        />
      </custom-layout>

      <div class="weui-cells">
        <file-field v-model="form.main.fa_attach" ref="fa_attach" />
      </div>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>费用关联{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <vendor-field
              slot="fad_vendname"
              v-model="item.fad_vendname"
              @select="onSelectVend($event, item)"
            />
            <customer-field
              slot="fad_custname"
              v-model="item.fad_custname"
              @select="onSelectCust($event, item)"
            />
            <div class="weui-cell" slot="fad_amount">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fad_amount || "金额"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.fad_amount"
                  placeholder="请填写实际金额"
                  minvalue="0.01"
                />
              </div>
            </div>
            <custom-field
              :label="customLabel.faq_text1 || '自定义字段1'"
              v-model="item.faq_text1"
              :caller="caller"
              fieldName="faq_text1"
              slot="faq_text1"
              hidden="true"
            />
            <custom-field
              :label="customLabel.faq_text2 || '自定义字段2'"
              v-model="item.faq_text2"
              :caller="caller"
              fieldName="faq_text2"
              slot="faq_text2"
              hidden="true"
            />
            <custom-field
              :label="customLabel.faq_text3 || '自定义字段3'"
              v-model="item.faq_text3"
              :caller="caller"
              fieldName="faq_text3"
              slot="faq_text3"
              hidden="true"
            />
            <custom-field
              :label="customLabel.faq_text4 || '自定义字段4'"
              v-model="item.faq_text4"
              :caller="caller"
              fieldName="faq_text4"
              slot="faq_text4"
              hidden="true"
            />
            <custom-field
              :label="customLabel.faq_text5 || '自定义字段5'"
              v-model="item.faq_text5"
              :caller="caller"
              fieldName="faq_text5"
              slot="faq_text5"
              hidden="true"
            />
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import FeeTypeField from "@/components/field/FeeTypeField.vue";
import FileField from "@/components/field/FileField.vue";
import VendorField from "@/components/field/VendorField.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  components: {
    CustomLayout,
    DateField,
    EmployeeField,
    CurrencyField,
    FeeTypeField,
    FileField,
    VendorField,
    CustomerField,
    CustomField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/feeapply",
      codeField: "fa_code",
      statusField: "fa_statuscode",
      caller: "FeeApply",
      xtype: "oa-feeapply-formpanel",
      form: {
        main: {},
        items: [{}],
      },
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main;
      if (!main.fa_date) {
        me.$weui.topTips("请填写申请日期", 2000);
        return;
      } else if (!main.fa_pleaseman) {
        me.$weui.topTips("请填写申请人", 2000);
        return;
      } else if (!main.fa_currency) {
        me.$weui.topTips("请选择币种", 2000);
        return;
      } else if (!main.fa_amount) {
        me.$weui.topTips("请填写申请金额", 2000);
        return;
      } else if (!main.fa_class) {
        me.$weui.topTips("请选择费用类型", 2000);
        return;
      } else if (!main.fa_content) {
        me.$weui.topTips("请填写费用内容", 2000);
        return;
      }

      me.p_save();
    },
    onSelectFeeType(selection) {
      var me = this,
        main = me.form.main;

      main.fa_class = selection.fcs_itemname;
      main.fa_islimit = selection.fcs_islimit;
    },
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },

    addItem() {
      var me = this,
        items = me.form.items;
      items.push({});
    },
    onSelectPleaseman(selected, main) {
      main.fa_pleasemancode = selected.em_code;
      main.fa_pleasemanid = selected.id;
      main.fa_department = selected.departmentDTO.dp_name;
      main.fa_departmentcode = selected.departmentDTO.dp_code;
      main.fa_departmentid = selected.departmentDTO.id;
    },
    onSelectVend(selected, item) {
      item.fad_vendid = selected.id;

      item.fad_custname = null;
      item.fad_custid = null;
    },
    onSelectCust(selected, item) {
      item.fad_custid = selected.id;

      item.fad_vendname = null;
      item.fad_vendid = null;
    },
  },
};
</script>